import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { seznamRetargetingHit } from '../lib/seznamRetargeting'

/** Odešle Seznam/Sklik retargetingový hit při každé změně cesty (SPA pageview). Gated souhlasem. */
export default function SeznamRetargeting() {
  const { pathname } = useLocation()
  useEffect(() => {
    seznamRetargetingHit()
  }, [pathname])
  return null
}
